import {Button, PrintIcon, ShareIcon, useToast} from '@kit';

import React, {useRef} from 'react';

import {printElement} from './print-element';

import css from './page-tools.module.css';

type Props = {
	/** что подписать в сообщении при репосте; по умолчанию — заголовок страницы */
	shareText?: string;
};

export const PageTools: React.FC<Props> = ({shareText}) => {
	const ref = useRef<HTMLDivElement>(null);
	const toast = useToast();

	const print = () => {
		const article = ref.current?.closest('article');
		if (article) printElement(article, document.title);
	};

	const copy = () =>
		navigator.clipboard?.writeText(location.href).then(() => toast.show({intent: 'success', title: 'Ссылка скопирована'}));

	const share = () => {
		if (!('share' in navigator)) return copy();
		return navigator.share({title: shareText || document.title, url: location.href}).catch(() => undefined);
	};

	return (
		<div className={css.tools} ref={ref} data-print-hide>
			<Button appearance="subtle" size="small" icon={<PrintIcon />} onClick={print} aria-label="Печать" title="Печать" />
			<Button appearance="subtle" size="small" icon={<ShareIcon />} onClick={share} aria-label="Поделиться" title="Поделиться" />
		</div>
	);
};
